// Import from NPM
// -------------------------------------
import React from "react";
import { useSelector } from "react-redux";
import { Image, Loader, Divider } from "semantic-ui-react";
import { useGetDeckQuery } from "@api/apiV6";
import ReactPlayer from "react-player/lazy";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// Import from Config
// -------------------------------------
import "@styles/readers.scss";

// Import Components
// -------------------------------------
import { Div, HDiv } from "@components/Generics.react";
import DocumentReader from "../decks/readers/DocumentReader.react";

// -------------------------------------
// Import APIs
// -------------------------------------

export default function ArticleRaw(props) {
    const { article } = props;
    const user = useSelector((state) => state.auth.user);

    const { data: deck } = useGetDeckQuery({
        id: article.decks[0],
        user_id: user._id,
        readerType: article.readerType,
    });

    const isPortrait = window.innerHeight > window.innerWidth;

    const articleImage = (
        <Div trench fluid noOverflow dropShadow>
            <Image src={article.image} fluid />
        </Div>
    );
    const articleHeader = (
        <Div fluid clearfix gapBottom>
            <Div wd={"calc(100% - 64px)"} float-left>
                <Div huge altText>
                    {article.name}
                </Div>
            </Div>
        </Div>
    );

    const deckView = () => {
        if (deck) {
            switch (article.readerType) {
                case "htmldeck":
                    return (
                        <Div fluid>
                            {article.image && articleImage}
                            <Div superpad>
                                {articleHeader}
                                <Divider />
                                <HDiv content={deck.content} />
                            </Div>
                        </Div>
                    );
                case "infodeck":
                    return (
                        <Div fluid>
                            <TransformWrapper>
                                <TransformComponent>
                                    <Image fluid src={deck.content} />
                                </TransformComponent>
                            </TransformWrapper>
                        </Div>
                    );
                case "docdeck":
                    return (
                        <Div fluid>
                            <DocumentReader deck={deck} noRecorder />
                        </Div>
                    );
                case "videck":
                    return (
                        <Div fluid>
                            <Div rounded className="video-responsive">
                                <ReactPlayer
                                    url={deck.content}
                                    className="react-player"
                                    playing={true}
                                    width="100%"
                                    height="100%"
                                    controls
                                />
                            </Div>
                        </Div>
                    );
                case "reeldeck":
                    return (
                        <Div fluid>
                            <Div rounded className="video-responsive-portrait">
                                <Div absolute>
                                    <ReactPlayer
                                        url={deck.content}
                                        className="react-player"
                                        playing={true}
                                        width="100%"
                                        height="100%"
                                        controls
                                    />
                                </Div>
                            </Div>
                        </Div>
                    );
                default:
                    return <Div />;
            }
        } else return <Loader active inverted />;
    };

    // ========================= Render Function =================================

    return (
        <Div fullht autoOverflowY basepad={isPortrait}>
            {deckView()}
        </Div>
    );
}
